export const calculateAge = (birthday) => {
  let today = new Date(),
    dob = new Date(birthday),
    diff = today.getTime() - dob.getTime(),
    years = Math.floor(diff / 31556736000);
  // days_diff = Math.floor((diff % 31556736000) / 86400000),
  // months = Math.floor(days_diff / 30.4167),
  // days = Math.floor(days_diff % 30.4167);
  return years ?? 0;
};

export const weekDays = () => {
  const weekDays = {
    Mo: "Даваа",
    Tu: "Мягмар",
    We: "Лхагва",
    Th: "Пүрэв",
    Fr: "Баасан",
    Sa: "Бямба",
    Su: "Ням",
  };
  return weekDays;
};

export function toHex(str) {
  var result = "";
  for (var i = 0; i < str.length; i++) {
    result += str.charCodeAt(i).toString(16);
  }
  return result;
}
